import {useLocation} from "react-router-dom";
import SelectField from "../../../components/Formik/Select";
import {useFormik} from "formik";
import * as Yup from "yup";
import {Tabs} from "flowbite-react";
import {useState, useEffect} from "react";
import WebinarModal from "../../../components/Broker/Webinars/WebinarModal";
import {Plus} from "react-feather";
import WebinarCard from "../../../components/Broker/Webinars/WebinarCard";
import {getIsBrokerSso, getMavProducts, getWebinars} from "../../../services/api/broker";
import LoadSpinner from "../../../components/Common/LoadSpinner";

const WebinarsPage = () => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const [isBrokerSso, setIsBrokerSso] = useState(null);
    const [webinarsData, setWebinarsData] = useState([]);
    const [metaData, setMetaData] = useState(null);
    const [dataFetched, setDataFetched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [webinarSelected, setWebinarSelected] = useState(null);
    const [webinarVideoAutoplay, setWebinarVideoAutoplay] = useState(false);

    const formik = useFormik({
        initialValues: {
            product: urlParams.get('product') ? urlParams.get('product') : null,
            status: 'upcoming',
            per_page: 9,
            page: 1
        },
        validationSchema: Yup.object().shape({}),
        onSubmit: async (values) => {
            fetchWebinarsData(values);
        },
    });

    const onActiveTabChange = (tab) => {
        const status = tab === 0 ? 'upcoming' : 'past';
        formik.setFieldValue('status', status);
        formik.setFieldValue('page', 1);
        setWebinarsData([]);
        setDataFetched(false);
        setMetaData(null);
    }

    const handleProductSelect = (product) => {
        formik.setFieldValue('product', product !== 'All products' ? product : null);
        formik.setFieldValue('page', 1);
        setWebinarsData([]);
        setDataFetched(false);
        setMetaData(null);
    }

    const loadMore = () => {
        formik.setFieldValue('page', formik.values.page + 1);
        formik.submitForm();
    }

    const fetchWebinarsData = async (values) => {
        try {
            setLoading(true);
            const {data, meta} = await getWebinars(values);
            setWebinarsData(prevData => values.page > 1 ? [...prevData, ...data] : data);
            setMetaData(meta);
            setDataFetched(true);
            setLoading(false);

            if (values.page === 1 && urlParams.get('id')) {
                const selectedWebinar = data.find((webinar) => webinar.id === parseInt(urlParams.get('id')));
                if (selectedWebinar) {
                    setWebinarSelected(selectedWebinar);
                }
            }
        } catch (e) {
            console.error('Error fetching webinars:', e);
        }
    };

    useEffect(() => {
            if (webinarsData.length === 0 && !dataFetched) formik.submitForm();
        }
        ,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [webinarsData, dataFetched]);

    const fetchProducts = async () => {
        try {
            const response = await getMavProducts();
            const transformedProducts = response.map(product => ({
                value: product.id,
                name: product.name,
            }));
            setProducts(transformedProducts);
        } catch (e) {
            console.error('Error fetching products:', e);
        }
    };

    const fetchSsoBroker = async () => {
        try {
            const response = await getIsBrokerSso();
            setIsBrokerSso(response.sso);
        } catch (e) {
            console.error('Error fetching sso info:', e);
        }
    };

    useEffect(() => {
            if (isBrokerSso === null) fetchSsoBroker();
            if (products.length === 0) fetchProducts();
        }
        ,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [products]);

    const changeWebinarRegistrationStatus = (webinarId, status) => {
        const updatedWebinars = webinarsData.map((webinar) => {
            if (webinar.id === webinarId) {
                webinar.has_registered = status;
            }
            return webinar;
        });
        setWebinarsData(updatedWebinars);
    }

    return (
        <div style={{
            marginTop: '-32px'
        }}>
            {webinarSelected && <WebinarModal
                changeWebinarRegistrationStatus={changeWebinarRegistrationStatus}
                onClose={() => {
                    setWebinarSelected(null);
                    setWebinarVideoAutoplay(false);
                }} webinar={webinarSelected} videoAutoplay={webinarVideoAutoplay} isBrokerSso={isBrokerSso}/>}

            <div
                style={{background: "linear-gradient(27deg, #1D2939 8.33%, #344054 91.67%)"}}
                className={"sl-flex sl-flex-col sl-gap-3 sl-align-center sl-pt-80 sl-pb-80"}>
                <span
                    className={"sl-pl-3 sl-pr-3 sl-pt-1 sl-pb-1 sl-border-radius-16 sl-bg-primary-50 sl-text-sm sl-text-primary-700"}>Meet
                    a Vendor
                </span>
                <div className={"sl-flex sl-flex-col sl-gap-2"}>
                    <span className={"sl-font sl-font-semibold sl-text-white sl-heading-xl "}>Webinars</span>
                    <span className={"sl-font sl-text-lg sl-text-white"}> Join our vendor-led webinars to stay ahead with the latest trends, insights, and strategies.</span>
                </div>
            </div>

            <div
                className={"sl-flex sl-flex-row sl-justify-space-between sl-pt-32 sl-pb-16 sl-container sl-m-auto sl-align-center"}>
                <div className={"sl-w-90 sl-max-w-90"}>
                    <SelectField formik={formik} name={'product'} options={products} onChange={handleProductSelect}
                                 elementClasses={'sl-max-w-89'}/>
                </div>

                <div className={"filter_tabs"}>
                    <Tabs variant="cs_tabs_pills" onActiveTabChange={onActiveTabChange}>
                        <Tabs.Item title="Upcoming"/>
                        <Tabs.Item title="Past recordings"/>
                    </Tabs>
                </div>
            </div>
            <div className={"sl-content-divider"}/>

            <div className={"sl-container sl-m-auto sl-flex sl-flex-col "}>

                {!loading && dataFetched && webinarsData.length === 0 && (
                    <div className="sl-w-full sl-text-center sl-mt-6">
                        <span className={"sl-font sl-heading-sm sl-font-semibold"}>
                            No {String(formik.values.status).charAt(0).toUpperCase() + String(formik.values.status).slice(1)} Webinars
                        </span>
                        <p className={"sl-font sl-text-md sl-text-center sl-mt-4 sl-text-gray-700"}>
                            There are
                            no {formik.values.status} webinars {formik.values.status === 'upcoming' ? 'scheduled' : ''} at
                            the moment. Check back soon for updates!
                        </p>
                    </div>
                )}

                <div style={{
                    gap: '40px 20px'
                }} className={"sl-pt-40  sl-flex sl-flex-row sl-flex-wrap"}>

                    {webinarsData.map((item, index) => <WebinarCard webinar={item} key={index} index={index}
                                                                    setWebinarSelected={setWebinarSelected}
                                                                    setWebinarVideoAutoplay={setWebinarVideoAutoplay}/>)}
                </div>

                <div className={"sl-flex sl-flex-row sl-w-full sl-justify-center sl-pb-80 sl-pt-80"}>
                    {metaData && (webinarsData.length < metaData.pagination.total) && !loading && (
                        <button
                            onClick={loadMore}
                            className={"sl-flex sl-flex-row sl-btn sl-btn-tertiary sl-btn-xl sl-w-fit-content sl-align-center sl-gap-2"}>
                            <Plus size={20}/>
                            <span
                                className={"sl-text-md sl-text-gray-700 sl-font-medium"}>{"Show more Webinars"}</span>
                        </button>
                    )}

                    {loading && (
                        <div className="sl-flex sl-justify-center">
                            <div>
                                <LoadSpinner/>
                                <p className={`sl-mt-4 sl-text-gray-700 sl-text-sm`}>Loading...</p>
                            </div>
                        </div>
                    )}
                </div>

            </div>
        </div>
    );

}

export default WebinarsPage;
